import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../promotions.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { CurrencyPipe, formatDate } from '@angular/common';
const helper = new JwtHelperService();
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';


@Component({
  selector: 'app-carrier-promotions',
  templateUrl: './carrier-promotions.component.html',
  styleUrls: ['./carrier-promotions.component.scss'],
  providers: [CurrencyPipe]
})
export class CarrierPromotionsComponent extends FeaturesBaseComponent
  implements OnInit, OnDestroy {
  ngStyle: { [klass: string]: any; }  
  data;
  columnDefs;
  columnhistoryDefs;
  rowData: any = [];
  rowSelection: string;
  selected: any = "one month";
  isButtonDisabled:boolean

  rowhistoryData: any = [];
  rowhistorySelection: string;

  searchValue;
  searchhistoryValue;
  showManagePromotion: boolean = false;
  selectedRows: any;
  showEditRetailer: boolean = false;
  showDeleteRetailer: boolean = false;
  toInactive: any = [];
  dateSelected: any;
  occasionRewardHideShow: boolean = true;
  historyDays = [
    { days: 30, value: "Next 30 days" },
    { days: 60, value: "Next 60 days" },
    { days: 90, value: "Next 90 days" },
  ];
  selectedDays = this.historyDays[0].days;
  gridApi: any;
  gridColumnApi: any;
  selectedPromotion: any;
  display: boolean = false;
  userRole: string ='';

  constructor(private router: Router, private promotionService: PromotionsService, private currencyPipe: CurrencyPipe, private dialog: MatDialog,private adminViewServices:AdminViewService) {
    super();
      this.promotionService.getcarrierPromotions().subscribe(res => {
        let resData: any = res;
        if (resData.httpcode == 200) {
          resData = resData.data;
          this.setGrid(resData);
        }
      })
  }

  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'Carrier-Promotions.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      //  //creditDate lastFundTransferedDttm autoReloadedDate
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'promotionStartdttm' || 
      cellParams.column.colId === 'promotionEnddttm' || 
      cellParams.column.colId === 'createdDttm') {
        return moment(cellParams.value).format('MM/DD/YYYY')
      }  else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }
  ngOnInit(): void {
    super.ngOnInit();
    const token: string = localStorage.getItem('accessToken'); 
    let decoded_token: any = helper.decodeToken(token);
    this.userRole= decoded_token.role;

    this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }



  

  onInactive() {
  }



  setGrid(data: any) {
    this.rowData = data;
    const self = this;
    this.columnDefs = [
      { field: "null", headerName: "Action", checkboxSelection: true, width: 120 },
      { field: 'carrierPromotionId', headerName: 'carrierPromotionId', width: 0, hide: true, sort: "desc" },
      { field: "editedPromotionName", headerName: "Promotion Name", width: 200 },
      { field: "editedPromotionDescription", headerName: "Description", width: 470 },
      { field: "applicableMaxAmount", headerName: "Max Amount ", width: 180, cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value);      
      } },
      { field: "applicableMinAmount", headerName: "Min Amount ", width: 180, cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value);        
      } },
      { field: "promotionStartdttm", headerName: "Start Date", width: 150, cellRenderer: (data) => {
        return moment(data.value).format('MM/DD/YYYY');        
      }  },
      { field: "promotionEnddttm", headerName: "End Date", width: 150, cellRenderer: (data) => {
        return moment(data.value).format('MM/DD/YYYY');        
      }  },
      { field: "tilaCountry", headerName: "Tila Country", width: 200 },
      { field: "tilaCarrier", headerName: "Tila Carrier", width: 200 },
      
      { field: "createdDttm", headerName: "Updated Date", width: 180, cellRenderer: (data) => {
        return moment(data.value).format('MM/DD/YYYY');     
      }  },
      { field: "isCertified", headerName: "Is Certified?", width: 200, pinned: 'right', cellRenderer: (data) => {
        return data.value == 'Yes' ? `${data.value} <span class="cur-point text-center rounded-pill bg-main px-2 py-1"> Notify </span>` : data.value;
      }, onCellClicked: (params) =>{
        self.handleNotify(params.data)
      }},
    ];
  }
  handleNotify(data){
    if(data.isCertified == 'Yes'){
      this.promotionService.notifyUsersMessageCarrierPromo(data.carrierPromotionId).subscribe(res => {
        if (res['httpcode'] == 200){
          this.toastrService.success('Notification sent to users', 'Success!')
        }
      })
    }
      
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length! > 0) {
      this.selectedPromotion = this.selectedRows[0];
      this.showManagePromotion = true;
      return
    }
    this.showManagePromotion = false;
  }

  createNewPromotion() {
    //let _carrierPromotionId = this.selectedRows[0].carrierPromotionId;
    this.router.navigate([`/features/promotions/create-carrier-promotion`])

  }


  manageSelectedPromotion(){
   
    ;
    if(this.userRole == 'Super Admin'|| this.userRole == 'Sub Admin'){
      let _carrierPromotionId = this.selectedRows[0].carrierPromotionId;
      this.router.navigate([`/features/promotions/map-carrier-promotion/${_carrierPromotionId}`])
      return;
    }
    this.dialog.open(DialogComponent, {
      width: "50vw",
      maxHeight: '90vh',
      panelClass: "dialog-overlay",
      data: {
        cntxt: 'promotion',
        promotionName: this.selectedRows[0].editedPromotionName,
        carrier: this.selectedRows[0].tilaCarrier,
        validityFrom:  this.selectedRows[0].promotionStartdttm,
        validityTo:  this.selectedRows[0].promotionEnddttm,
        amountApplicable: `$ ${ this.selectedRows[0].minTopUpAmount} - $ ${ this.selectedRows[0].applicableMaxAmount}`,
        promoDesc: `${ this.selectedRows[0].editedPromotionDescription}`,
      },
    });

  }

  rolecheck(){ //alert("hello")
    const token: string = localStorage.getItem('accessToken'); 
    let decoded_token: any = helper.decodeToken(token);
    let current_userRole: string = decoded_token.role;
   
    if (current_userRole == "Sales Rep"){
      this.display = true
      return //"{'diasplay':'none'}";
    }else{
      this.display = false
      return;
    }
  }
}
